<template>
    <div id="data" />
</template>

<script>
import utils from '../../js/utils';

export default {
    store: [
        'api',
        'user',
        'topics',
        'topicsIndex',
        'courses',
        'coursesIndex',
        'units',
        'unitsIndex',
        'fullDataIndex',
        'traits',
        'myTraits',
        'traitsIndex',
        'progress',
    ],
    data () {
        return {
            usePgap: false,
            progressUnitsIndex: [],
            progressCoursesIndex: [],
            progressTopicsIndex: [],
            hasUpdateNotice: false,
        };
    },
    mounted: function () {
    },
    created: function () {
        this.listenToSw();
        this.$events.on('user-progress-fetched', () => {
            if (!this.courses.length || !this.topics.length || !this.units.length) return setTimeout(() => {
                this.buildFullIndex()
            }, 2000);
            this.buildFullIndex()
        });
        this.cacheIsReady();
        this.$events.on('reload-data-cache', () => {
            utils.actionLog({location: 'Data', method: 'created', action: 'reload-data-cache'});
            const ts = Math.round((new Date()).getTime() / 1000);
            this.cacheIsReady(ts);
        });
        // if (pgap || !navigator.serviceWorker) {
        //     // todo build offline pgap cache here
        //     return this.cacheIsReady();
        // }
        // navigator.serviceWorker.register(location.hostname === 'localhost' ? '/static/data-sw.js' : '/app/static/data-sw.js');
        // // Load controlled and uncontrolled pages once the worker is active.
        // navigator.serviceWorker.ready.then(this.cacheIsReady);
    },
    methods: {
        fileDataSrc: (locationSrc) => {
            const branch = localStore.getItem('branch') || '';
            return (branch === 'DEV') ? `${locationSrc}-test.json` : `${locationSrc}.json`;
        },
        fileDataUrl: function (urlBuildOptions) {
            //  urlBuildOptions: {
            //     fileSrc: string;
            //     isFallBack: boolean;
            //     ts: any;
            //     usePgap: boolean;
            //  }

            const fileSrc = urlBuildOptions.fileSrc;
            const isFallBack = urlBuildOptions.isFallBack;
            const ts = urlBuildOptions.ts;
            const base = 'https://data.getcoral.app/CONTENT/';
            const fallBack = 'https://getcoral.s3.amazonaws.com/CONTENT/';
            const itemsToUse = this.fileDataSrc(fileSrc);

            utils.actionLog({
                location: 'Data',
                method: 'fileDataUrl',
                action: 'use',
                info: 'trait',
                dataValue: itemsToUse
            });

            if (isFallBack) {
                utils.actionLog({
                    location: 'Data',
                    method: 'fileDataUrl',
                    info: `Cannot get ${itemsToUse}: Cloudfront rejected. Trying to use fallback URL.`
                });
            }

            return this.usePgap
                ? `${isFallBack ? fallBack : base}${itemsToUse}${ts ? `?ts=${ts}` : ''}`
                : `${isFallBack ? fallBack : base}${itemsToUse}`;
        },
        listenToSw: function () {
            if ('serviceWorker' in navigator) {
                navigator.serviceWorker.onmessage = (evt) => {
                    utils.actionLog({location: 'Data', method: 'listenToSw', info: 'SW news', dataValue: evt});
                    var message = JSON.parse(evt.data);
                    var isRefresh = message.type === 'refresh';
                    var lastETag = localStore.currentETag;
                    var isNew = lastETag !== message.eTag;
                    if (isRefresh && isNew) {
                        // this we do not use, to show an update btn
                        if (lastETag) { // which you dont do first time
                            this.hasUpdateNotice = true;
                        }
                        localStore.currentETag = message.eTag;
                        this.cacheIsReady();
                    }
                };
            }
        },
        cacheIsReady: function (ts) {
            this.getUnits(ts);
            this.getTopics(ts);
            this.getCourses(ts);
            this.getTraits(ts);
        },
        getTraits: function (ts) {
            const complete = (data) => {
                this.traits = data;
                utils.actionLog({location: 'Data', method: 'getTraits', action: 'done', info: 'trait', dataValue: this.traits.length});
                let currentTrait = '';
                for (let i = 0; i < this.traits.length; i++) {
                    // Used to show categories
                    this.traits[i].isFirst = false;
                    if (this.traits[i].groupName !== currentTrait) {
                        this.traits[i].isFirst = true;
                        currentTrait = this.traits[i].groupName;
                    }
                    this.traitsIndex[this.traits[i].id] = this.traits[i];
                }
            }
            // `${this.api}/traits`
            utils.actionLog({location: 'Data', method: 'getTraits', action: 'load', info: 'trait'});
            // In order to avoid unexpected things while experimenting with traits locally - there will be used
            // "traits-test.json" file because it's going to be updated while developing
            this.$http.get(this.fileDataUrl({ fileSrc: 'traits', isFallBack: false, ts}))
                .then(response =>
                    complete(response.body || []),
                () =>
                    this.$http.get(this.fileDataUrl({ fileSrc: 'traits', isFallBack: true, ts}))
                        .then(responseFallback => complete(responseFallback.body || []),
                            rejectedFallback => utils.failedRequest('full', rejectedFallback, true))
                );
        },
        getTopics: function (ts) {
            const complete = data => {
                this.topics = data;
                utils.actionLog({location: 'Data', method: 'getTopics', action: 'done', info: 'topic', dataValue: this.topics.length});
                for (let i = 0; i < this.topics.length; i++) {
                    this.topicsIndex[this.topics[i].id] = this.topics[i];
                }
                if (this.courses.length && this.topics.length && this.units.length) this.buildFullIndex();
            }
            // `${this.api}/topics`
            utils.actionLog({location: 'Data', method: 'getTopics', action: 'load', info: 'topic'});
            // In order to avoid unexpected things while experimenting with topics locally - there will be used
            // "topics-test.json" file because it's going to be updated while developing
            this.$http.get(this.fileDataUrl({ fileSrc: 'topics', isFallBack: false, ts}))
                .then(response =>
                    complete(response.body || []),
                () =>
                    this.$http.get(this.fileDataUrl({ fileSrc: 'topics', isFallBack: true, ts}))
                        .then(responseFallback => complete(responseFallback.body || []),
                            rejectedFallback => utils.failedRequest('full', rejectedFallback, true))
                );
        },
        getCourses: function (ts) {
            const complete = (data) => {
                this.courses = data;
                utils.actionLog({location: 'Data', method: 'getCourses', action: 'done', info: 'course', dataValue: this.courses.length});

                for (let i = 0; i < this.courses.length; i++) {
                    this.coursesIndex[this.courses[i].id] = this.courses[i];
                }
                // console.log('courses loaded: ', this.courses.length);
                if (this.courses.length && this.topics.length && this.units.length) this.buildFullIndex();
            }

            // `${this.api}/courses`
            utils.actionLog({location: 'Data', method: 'getCourses', action: 'load', info: 'course'});
            // In order to avoid unexpected things while experimenting with courses locally - there will be used
            // "courses-test.json" file because it's going to be updated while developing
            this.$http.get(this.fileDataUrl({ fileSrc: 'courses', isFallBack: false, ts}))
                .then(response =>
                    complete(response.body || []),
                () =>
                    this.$http.get(this.fileDataUrl({ fileSrc: 'courses', isFallBack: true, ts}))
                        .then(responseFallback => complete(responseFallback.body || []),
                            rejectedFallback => utils.failedRequest('full', rejectedFallback, true))
                );
        },
        getUnits: function (ts) {
            const complete = (data) => {
                this.units = data;
                utils.actionLog({location: 'Data', method: 'getUnits', action: 'done', info: 'unit', dataValue: this.units.length});

                for (let i = 0; i < this.units.length; i++) {
                    this.unitsIndex[this.units[i].id] = this.units[i];
                }

                if (this.courses.length && this.topics.length && this.units.length) this.buildFullIndex();
            }
            // `${this.api}/units`
            utils.actionLog({location: 'Data', method: 'getUnits', action: 'load', info: 'unit'});
            // In order to avoid unexpected things while experimenting with units locally - there will be used
            // "units-test.json" file because it's going to be updated while developing
            this.$http.get(this.fileDataUrl({ fileSrc: 'units', isFallBack: false, ts}))
                .then(response =>
                    complete(response.body || []),
                () =>
                    this.$http.get(this.fileDataUrl({ fileSrc: 'units', isFallBack: true, ts}))
                        .then(responseFallback => complete(responseFallback.body || []),
                            rejectedFallback => utils.failedRequest('full', rejectedFallback, true))
                );
        },
        buildFullIndex: function () {
            if (!this.courses.length || !this.topics.length || !this.units.length) return;
            utils.actionLog({ location: 'Data', method: 'buildFullIndex', info: 'indexing...' });
            this.progressTopicsIndex = [];
            this.progressCoursesIndex = [];
            this.progressUnitsIndex = [];
            for (let i = 0; i < this.progress.length; i++) {
                const p = this.progress[i];
                if (p.type === 'unit') {
                    if (!this.progressUnitsIndex[p.itemId])
                        this.progressUnitsIndex[p.itemId] = p;
                    else if (!this.progressUnitsIndex[p.itemId].completed)
                        this.progressUnitsIndex[p.itemId] = p;
                    // the above deals witha weird edge case where it created two rows
                    // in the mysql db
                } else if (p.type === 'course') {
                    this.progressCoursesIndex[p.courseId] = p;
                } else if (p.type === 'topic') {
                    this.progressTopicsIndex[p.topicId] = p;
                }
            }
            // console.log('Build full index');
            this.fullDataIndex = JSON.parse(JSON.stringify(this.topicsIndex));
            this.fullDataIndex[0] = {
                courses: [],
                name: 'Unassigned'
            };
            for (let i = 0; i < this.topics.length; i++) {
                const topic = this.topics[i];
                if (!this.fullDataIndex[topic.id]) this.fullDataIndex[topic.id] = {};
                Vue.set(this.topicsIndex[topic.id], 'completed', false);
                Vue.set(this.topicsIndex[topic.id], 'started', false);
                if (this.progressTopicsIndex[topic.id]) {
                    this.topicsIndex[topic.id].started = true;
                    if (this.progressTopicsIndex[topic.id].completed) this.topicsIndex[topic.id].completed = true;
                }
                this.fullDataIndex[topic.id].courses = [];
            }
            for (let i = 0; i < this.courses.length; i++) {
                const course = this.courses[i];
                Vue.set(this.coursesIndex[course.id], 'completed', false);
                Vue.set(this.coursesIndex[course.id], 'started', false);
                if (this.progressCoursesIndex[course.id]) {
                    this.coursesIndex[course.id].started = true;
                    if (this.progressCoursesIndex[course.id].completed) this.coursesIndex[course.id].completed = true;
                }
                course.units = [];
                Vue.set(this.coursesIndex[course.id], 'units', []);
                if (this.fullDataIndex[course.topicId] && this.fullDataIndex[course.topicId].courses)
                    this.fullDataIndex[course.topicId].courses.push(this.coursesIndex[course.id]);
                else {
                    // console.log('Invalid topic: ', course.topicId);
                }
            }
            for (let i = 0; i < this.units.length; i++) {
                const unit = this.units[i];
                // console.log('Add unit', unit.id)
                // if (unit.courseId === 176) console.log('FOUND', unit.id)
                if (!this.unitsIndex[unit.id]) this.unitsIndex[unit.id] = unit;
                Vue.set(this.unitsIndex[unit.id], 'liked', false); // for responsiveness
                Vue.set(this.unitsIndex[unit.id], 'bookmarked', false); // for responsiveness
                Vue.set(this.unitsIndex[unit.id], 'completed', false);
                Vue.set(this.unitsIndex[unit.id], 'started', false);
                Vue.set(this.unitsIndex[unit.id], 'progress', 0);
                if (this.progressUnitsIndex[unit.id]) {
                    this.unitsIndex[unit.id].started = true;
                    if (this.progressUnitsIndex[unit.id].completed) this.unitsIndex[unit.id].completed = true;
                }
                if (unit.courses) {
                    for (let j = 0; j < unit.courses.length; j++) {
                        const item = unit.courses[j];
                        if (!this.coursesIndex[item.courseId]) continue;
                        this.coursesIndex[item.courseId].units.push(this.unitsIndex[unit.id]);
                    }
                }

            }
            // this.recentUnits();
            utils.actionLog({ location: 'Data', method: 'buildFullIndex', info: 'indexing done' })

            if (this.progress.length) {
                this.$events.fire('get-home');
                this.$events.fire('get-explore');
            }
        },
        recentUnits: function () {
            // aka course 38
            // needs mytraits
            const tmpCourses = [];
            let units = this.units.slice().sort((a, b) => {
                var dateA = new Date(a.createdAt);
                var dateB = new Date(b.createdAt);
                return dateA - dateB;
            }).reverse();
            for (let i = 0; i < units.length; i++) {
                var fortnightAway = new Date(Date.now() - 12096e5 * 2);
                if ((new Date(units[i].createdAt).getTime() - fortnightAway.getTime()) > 0) {
                    if (units[i].courseId && units[i].topicId !== 5 &&
                        tmpCourses.indexOf(units[i].courseId) === -1 &&
                        // utils.checkTraits(this.myTraits, this.coursesIndex[units[i].courseId]) &&
                        utils.checkTraits(this.myTraits, this.unitsIndex[units[i].id]) &&
                        tmpCourses.length < 5) {
                        if (this.coursesIndex[units[i].courseId] &&
                            this.topicsIndex[this.coursesIndex[units[i].courseId]] &&
                            this.topicsIndex[this.coursesIndex[units[i].courseId]].type === 'learn'
                        )
                            tmpCourses.push(units[i].courseId);
                    }
                }
            }
            if (tmpCourses.length) {
                this.fullDataIndex[38].courses = [];
                for (let i = 0; i < tmpCourses.length; i++) {
                    this.fullDataIndex[38].courses.push(this.coursesIndex[tmpCourses[i]])
                }
            }
        },
    }
};
</script>
<style lang="less" scoped>
#data {
    display: hidden;
}
</style>
